<template>
    <div class="col-12 col-md-6 col-xl-3">
            <h5 data-test="footerHead1" id="footerHead1">
													{{ $t(data.moduleHeading) }}
												</h5>
            <ul>
              <li v-for="(list, key) in data.footerLinks" :key="key">
                <router-link
                  :to="{path :$t(list.path),
                  query: {
                    display_text: $t(list.displayText),
                  }}"

                >{{$t(list.text)}}</router-link>
              </li>
            </ul>
          </div>
</template>
<script>
export default {
	props: {
		data: {
			type: Object
		}
	}
}
</script>
